import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function SaferRecruitmentPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    SAFER RECRUITMENT POLICY STATEMENT
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Ensuring Safe Hiring Practices and Child Protection
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Akindele Bakarey</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V14 - 2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>01/08/2025</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>01/08/2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2026</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}><strong>ALL EMPLOYEES and FREELANCE STAFF</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Statement - Introduction */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The safe recruitment of staff in DTK College is the first step to safeguarding and promoting the welfare of learners in education. The College is committed to safeguarding and promoting the welfare of children and young people and expects all staff and volunteers to share this commitment. It is recognised that this can only be achieved through sound procedures, good inter-agency cooperation and the recruitment and retention of competent, motivated employees who are suited to, and fulfilled in the roles they undertake.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK College recognises the value of and seeks to achieve a diverse workforce which includes people from different backgrounds, with different skills and abilities. The College is committed to ensuring that the recruitment and selection of all who work within the College is conducted in a manner that is systematic, efficient, effective and promotes equality of opportunity. The College will uphold its obligations under law and national collective agreements to not discriminate against applicants for employment on the grounds of age, sex, sexual orientation, marital status, disability, race, colour, nationality, ethnic origin, religion, or creed.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    This document provides a good practice framework to comply with the principles set down in DTK College's Equal Opportunities and Safeguarding Policies. The practices described in this document are designed to ensure a fair and objective process.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    All posts within DTK College are exempt from the Rehabilitation of Offenders Act 1974 and therefore all applicants for paid work and relevant volunteers will be required to declare all unfiltered convictions, cautions and bind-overs, including those regarded as spent and to have a Children's Barred List and an Enhanced Criminal Records Disclosure check. A previously issued Disclosure and Barring Service Disclosure Certificate will only be accepted if the individual is registered with the DBS Update Service. Workers and volunteers will also be required to complete the other appropriate safer recruitment checks as set out in <em>Keeping Children Safe in Education</em>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Criminal Convictions and Fair Treatment */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK College is committed to ensuring that people who have been convicted are treated fairly and given every opportunity to establish their suitability for positions. Having a criminal record will not necessarily be a bar to obtaining a position. This will depend on the background, nature, and circumstances of the offence(s). The College's Recruitment Procedure outlines the considerations that will be considered when determining the relevance of a criminal record to the post.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The Disclosure and Barring Service has published a Code of Practice and accompanying explanatory guide. This College is committed to ensuring that it meets the requirements of the Disclosure and Barring Service in relation to the processing, handling, and security of Disclosure information.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* College Commitments */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    The College will:
                  </h3>

                  <div style={{ marginBottom: '30px' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', lineHeight: '1.9', marginBottom: '15px' }}>
                      1. Implement robust recruitment procedures and checks for appointing staff and volunteers to ensure that reasonable steps are taken not to appoint a person who is unsuitable to work with children, or who is disqualified from working with children, or does not have the suitable skills and experience for the intended role.
                    </p>

                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                      The following pre-employment checks will be undertaken:
                    </p>

                    <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '0' }}>
                      <li>Receipt of at least two satisfactory references</li>
                      <li>Verification of the candidate's identity</li>
                      <li>A Children's Barred List check (when undertaking regulated activity)</li>
                      <li>A satisfactory enhanced DBS disclosure</li>
                      <li>A prohibition from teaching check (teachers only)</li>
                      <li>Verification of the candidate's medical fitness</li>
                      <li>Verification of qualifications</li>
                      <li>Verification of professional status where required e.g. QTLS status</li>
                      <li>The production of evidence of the right to work in the UK</li>
                      <li>If the person has lived or worked outside the UK, make any further checks the College consider appropriate.</li>
                    </ul>
                  </div>

                  <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', lineHeight: '1.9', marginBottom: '15px' }}>
                    2. Keep and maintain a single central record of recruitment and vetting checks, in line with the DfES requirements.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', lineHeight: '1.9', marginBottom: '15px' }}>
                    3. Ensure that the terms of any contract with a contractor or agency requires them to adopt and implement measures described in this procedure. The College will monitor the compliance with these measures.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', lineHeight: '1.9', marginBottom: '15px' }}>
                    4. Require staff who are convicted or cautioned for any offence during their employment with DTK College to notify DTK College, in writing of the offence and penalty.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', lineHeight: '1.9', marginBottom: '0' }}>
                    5. The College will refer to the Local Authorities internal registers of individuals whose previous employment history may give cause for concern and will refer individuals to the Disclosure and Barring Service as required for possible inclusion on the Children's Barred List.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default SaferRecruitmentPolicy;